import React, { useState } from "react";
import MainButton from "./MainButton";
import AddIcon from "@mui/icons-material/Add";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Paper,
  Button,
  TextField,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tooltip,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices"; // Иконка метлы
import RestoreIcon from "@mui/icons-material/Restore"; // Альтернатива - стрелка назад

import Legend from "./Legend";
import { BASE_API_URL } from "../const";
import Api from "../Api";
import filmStore from "../../Store/FilmStore";
import channelStore from "../../Store/ChannelStore";
import { observer } from "mobx-react-lite";
import { getErrorMessage } from "../../utils/errorHandler";

/* Левый блок с таблицей */
const MainLeft = observer(({ setManageBlock, manageBlock, hideMetUid }) => {
  const handleAddClick = async (channelId) => {
    try {
      const response = await Api.post(`${BASE_API_URL}/api/timeline/addPack`, {
        channel_id: channelId,
      });

      // Извлекаем count из ответа
      const count = response.data?.data?.count;

      toast.success(`Добавлено: ${count}`);
      channelStore.getChannels();
    } catch (error) {
      console.error("Ошибка POST запроса:", error);

      toast.error(
        `❌ ${getErrorMessage(error, "Ошибка при добавлении канала")}`
      );
    }
  };

  const handleAddSequelClick = async (channelId) => {
    try {
      const response = await Api.post(`${BASE_API_URL}/api/timeline/addBlock`, {
        channel_id: channelId,
      });
      // Извлекаем count из ответа
      const count = response.data?.data?.count;

      toast.success(`Сиквел добавлен. Добавлено: ${count}`);
      channelStore.getChannels();
    } catch (error) {
      console.error("Ошибка POST запроса:", error);

      const serverMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Ошибка при добавлении сиквела.";

      toast.error(`❌ ${serverMessage}`);
    }
  };

  const handleRestart = async (channelId) => {
    try {
      const response = await Api.post(`${BASE_API_URL}/api/timeline/restart`, {
        channel_id: channelId, // передаём id в теле запроса
      });

      if (response.status === 200) {
        toast.success("Рестарт выполнен");
        channelStore.getChannels();
      } else {
        toast.error("Рестарт не выполнен");
      }
    } catch (error) {
      console.error("Ошибка при рестарте:", error);

      const serverMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Рестарт не выполнен";

      toast.error(`❌ ${serverMessage}`);
    }
  };

  const handleRollback = async (channelId) => {
    try {
      const response = await Api.post(`${BASE_API_URL}/api/timeline/rollback`, {
        channel_id: channelId,
      });

      if (response.status === 200) {
        toast.success("Откат выполнен");
        channelStore.getChannels();
      } else {
        toast.error("Откат не выполнен");
      }
    } catch (error) {
      console.error("Ошибка при откате:", error);

      const serverMessage =
        error?.response?.data?.message || error?.message || "Откат не выполнен";

      toast.error(`❌ ${serverMessage}`);
    }
  };

  return (
    <Box
      sx={{
        width: "15%", // Ширина левого блока — 15% от экрана
        minWidth: "380px",
        borderRight: "1px solid #ddd",
        height: "100%", // Высота — на всю страницу
        padding: 1,
        boxSizing: "border-box",
      }}
    >
      <Typography variant="h6" align="center" gutterBottom>
        Список каналов
      </Typography>
      <Box
        sx={{
          opacity: manageBlock ? 0.5 : 1,
          transition: "opacity 0.3s",
          pointerEvents: manageBlock ? "none" : "auto",
        }}
      >
        <TableContainer
          component={Paper}
          sx={{ maxHeight: "calc(100% - 40px)" }}
        >
          <Table
            sx={{
              "& .MuiTableCell-root": {
                padding: "6px 8px", // Уменьшаем отступы
                verticalAlign: "middle",
              },
            }}
          >
            <TableBody sx={{ border: "1px solid #ccc" }}>
              {channelStore.channels.map((element, index) => {
                const fontColor = element.font_color;
                return (
                  <TableRow key={index}>
                    <TableCell
                      sx={{
                        backgroundColor: fontColor,
                        color: element.commit === 0 ? "red" : "inherit",
                      }}
                    >
                      {element.name}
                    </TableCell>

                    <TableCell
                      sx={{
                        width: "180px", // чуть больше для красоты
                        padding: "6px 8px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Tooltip
                          title="Добавить контент"
                          arrow
                          disableInteractive
                          componentsProps={{
                            tooltip: {
                              sx: {
                                transform: "none !important", // ❌ убираем scale(0.75) → scale(1)
                                transition: "none !important", // ❌ убираем плавность
                                fontSize: "0.8rem",
                                lineHeight: 1.2,
                                padding: "6px 8px",
                              },
                            },
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              lineHeight: 0, // 🔑 Ключ к устранению скачка
                            }}
                          >
                            <AddIcon
                              fontSize="small"
                              sx={{
                                color:
                                  element.rotation === "stream"
                                    ? "rgba(0, 100, 0, 0.9)"
                                    : "#bbb",
                                cursor:
                                  element.rotation === "stream"
                                    ? "pointer"
                                    : "not-allowed",
                                marginRight: "8px",
                              }}
                              onClick={
                                element.rotation === "stream"
                                  ? () => handleAddClick(element.id)
                                  : undefined
                              }
                            />
                          </Box>
                        </Tooltip>

                        {/* Второй плюсик в кружочке для добавления сиквела */}
                        <Tooltip
                          title="Добавить сиквел"
                          arrow
                          disableInteractive
                          componentsProps={{
                            tooltip: {
                              sx: {
                                transform: "none !important",
                                transition: "none !important",
                                fontSize: "0.8rem",
                                lineHeight: 1.2,
                                padding: "6px 8px",
                              },
                            },
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              lineHeight: 0,
                            }}
                          >
                            <AddCircleOutlineIcon
                              fontSize="small"
                              sx={{
                                color:
                                  element.rotation === "stream"
                                    ? "rgba(0, 100, 0, 0.9)"
                                    : "#bbb",
                                cursor:
                                  element.rotation === "stream"
                                    ? "pointer"
                                    : "not-allowed",
                                marginRight: "8px",
                              }}
                              onClick={
                                element.rotation === "stream"
                                  ? () => handleAddSequelClick(element.id)
                                  : undefined
                              }
                            />
                          </Box>
                        </Tooltip>

                        <Typography variant="body2">
                          {element.end_program_date
                            ? element.end_program_date.split(" ")[0]
                            : "Дата не указана"}
                        </Typography>

                        <Tooltip
                          title="Рестарт"
                          arrow
                          disableInteractive
                          componentsProps={{
                            tooltip: {
                              sx: {
                                transform: "none !important", // ❌ убираем scale(0.75) → scale(1)
                                transition: "none !important", // ❌ убираем плавность
                                fontSize: "0.8rem",
                                lineHeight: 1.2,
                                padding: "6px 8px",
                              },
                            },
                          }}
                        >
                          <AutorenewIcon
                            fontSize="small"
                            sx={{
                              color: "#888",
                              paddingLeft: "5px",
                              cursor: "pointer",
                              "&:hover": { color: "#000" },
                            }}
                            onClick={() => handleRestart(element.id)}
                          />
                        </Tooltip>

                        {/* Иконка метлы для отката изменений */}
                        <Tooltip
                          title="Откат изменений"
                          arrow
                          disableInteractive
                          componentsProps={{
                            tooltip: {
                              sx: {
                                transform: "none !important",
                                transition: "none !important",
                                fontSize: "0.8rem",
                                lineHeight: 1.2,
                                padding: "6px 8px",
                              },
                            },
                          }}
                        >
                          <CleaningServicesIcon
                            fontSize="small"
                            sx={{
                              color:
                                element.rotation === "stream" ? "#888" : "#bbb",
                              paddingLeft: "5px",
                              cursor:
                                element.rotation === "stream"
                                  ? "pointer"
                                  : "not-allowed",
                              "&:hover": {
                                color:
                                  element.rotation === "stream"
                                    ? "#d32f2f"
                                    : "#bbb",
                              },
                            }}
                            onClick={
                              element.rotation === "stream"
                                ? () => handleRollback(element.id)
                                : undefined
                            }
                          />
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {/* Кнопка и легенда вне контейнера с opacity */}
      <Box>
        <MainButton
          setManageBlock={setManageBlock}
          manageBlock={manageBlock}
          hideMetUid={hideMetUid}
        />
        <Legend hideMetUid={hideMetUid} />
      </Box>
    </Box>
  );
});

export default MainLeft;
